module.exports = __webpack_public_path__ + "img/theme4.4ef42a41.png";